yTos.utils.namespace('yTos.configuration.requireJSConfig.paths');


// espot.updater should also be included here because
// espot.productsUpdater extends it.
yTos.configuration.requireJSConfig.paths['espot.updater'] = 'espot.updater-0.3.0/espot.updater';
//yTos.configuration.requireJSConfig.paths['espot.updater'] = '/jsrepo/espot.updater/src/espot.updater';
